<div class="shareContainer">

  <div class="shareModalBox">
  
    <div class="imgShare">
      <img class="logoAvocadoShare" src="assets/imgs/avocados.svg" alt="Share">
    </div>

    <div class="backArrowSection">
      <ion-icon (click)="goBack()" name="close-outline"></ion-icon>
    </div>
    
    <span class="title-share">{{'shareWithYourFriends' | translate}}</span>

    <div class="txt-description">
      {{'friendsDontLetFriendsDateCarnists' | translate}}
    </div>
    <br>

    <ion-button class="shareButton" (click)="profileShare()">
      {{'share' | translate}}
    </ion-button>
  </div>
</div>